var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartloading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3564 0C101.451 0.000247394 130.712 29.2615 130.712 65.3564C130.712 101.451 101.451 130.712 65.3564 130.712C29.2615 130.712 0.000247426 101.451 0 65.3564C0 29.2613 29.2613 0 65.3564 0ZM65.3564 22.457C41.6641 22.457 22.457 41.6641 22.457 65.3564C22.4573 89.0486 41.6642 108.255 65.3564 108.255C89.0485 108.255 108.255 89.0485 108.255 65.3564C108.255 41.6642 89.0486 22.4573 65.3564 22.457Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0078 0.536133C66.2195 -0.650927 75.5785 0.139167 84.4609 2.85352C93.3434 5.56795 101.546 10.1447 108.521 16.2783C115.495 22.4118 121.083 29.9612 124.91 38.4238C128.738 46.8866 130.717 56.0684 130.717 65.3564H108.26C108.26 41.6641 89.0527 22.457 65.3604 22.457C63.5026 22.457 61.6724 22.5746 59.877 22.8037L57.0078 0.536133Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.694 65.6436C130.694 78.5697 126.861 91.2054 119.68 101.953C112.498 112.701 102.291 121.078 90.3486 126.024C78.4065 130.971 65.2656 132.266 52.5879 129.744C39.9102 127.222 28.2651 120.997 19.125 111.857L35.0049 95.9766C36.5991 97.5709 38.3224 99.0434 40.1621 100.377C46.5644 105.018 54.1244 107.799 62.0078 108.413C69.8914 109.027 77.7914 107.449 84.835 103.855C91.8786 100.262 97.7921 94.7912 101.922 88.0479C106.052 81.3045 108.237 73.551 108.237 65.6436H130.694Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartloading);
export default __webpack_public_path__ + "static/media/pieChartloading.3b221944060b92f3cd15c8f43188edf5.svg";
export { ForwardRef as ReactComponent };